const PlatformType = {
    MOBILE_WEB: 'mobile_web',
    WEB: 'web',
};

module.exports = {
    PlatformType,
};
